export interface QueryParameters {
  [key: string]: boolean | string | number | undefined;
}

export type Payload = Record<string, unknown>;

export class HttpError extends Error {
  constructor(
    public readonly status: number,
    public readonly endpoint: string,
    public readonly message: string,
    public readonly errorKey?: string,
    public readonly info?: Record<string, unknown>,
    public readonly innerError?: Error,
  ) {
    super(message);
  }
}
